import { render, staticRenderFns } from "./ImportEmailsPlanRelease.vue?vue&type=template&id=5521bbed&scoped=true&"
import script from "./ImportEmailsPlanRelease.vue?vue&type=script&lang=js&"
export * from "./ImportEmailsPlanRelease.vue?vue&type=script&lang=js&"
import style0 from "./ImportEmailsPlanRelease.vue?vue&type=style&index=0&id=5521bbed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5521bbed",
  null
  
)

export default component.exports